import { LoadableAfterPaint } from '@confluence/loadable';

export const InlineExternalImage = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InlineExternalImage" */ '../src/InlineExternalImage.tsx'
			)
		).InlineExternalImage,
});

export type { InlineExternalImageParams } from '../src/InlineExternalImage.tsx';
